import axios from '@/request';
import qs from 'qs';

export default {
  async list(params: any) {
    return axios.get('sensitive/list', { params });
  },
  async add(params: any) {
    return axios.post('sensitive/add', qs.stringify(params));
  }
};
